module.exports = __webpack_public_path__ + "img/resturant_back1.0d425a5f.jpg";